import React from 'react';

import { StripeInstanceContext } from 'src/providers/StripeInstanceProvider';

export const useStripeInstance = () => React.use(StripeInstanceContext);
